import { GenericStatus } from './generic-status';
import { HevoEntityMeta, RawHevoEntityMeta } from './entity-meta';
import { EntityAction, EntityRawAction } from '../../entity-actions/interfaces/entity-actions';

export enum SourceStatus {
  FAILED = 'FAILED',
  ERRORED = 'ERRORED',
  CREATED = 'CREATED',
  PAUSED = 'PAUSED',
  ACTIVE = 'ACTIVE',
  DELETING = 'DELETING',
  DELETED = 'DELETED'
}

// ui model
export interface SourceType {
  sourceType: string;
  baseSourceType?: string;
  displayName: string;
  id: string | number;
  description: string;
  version?: string;
  logo: string;
  logoDarkMode: string;
  documentationLink?: string;
  replicationTypes: {
    label: string;
    value: string;
    description: string;
  }[];
  properties?: {
    flatFileObjectSelectEnabled: boolean;
    walSlotMonitoringEnabled: boolean;
  };
}

// ui model
export interface Source extends HevoEntityMeta {
  id: number;
  seqId: number;
  name: string;
  sourceType: SourceType;
  status: GenericStatus<SourceStatus>;
  actions: EntityAction<SourceAction>[];
  integrationsCount?: number;
}

// backend response
export interface RawSourceType {
  type: string;
  display_name: string;
  description: string;
  logo_url: string;
  dark_mode_logo_url?: string | null;
  doc_link?: string;
  base_type?: string;
  version?: string;
  display_version?: string;
  supported_replication_types?: {
    type: string;
    display_name: string;
    description: string;
  }[];
  properties?: {
    flat_file_object_selection_enabled?: boolean;
    wal_slot_monitoring_enabled?: boolean;
  };
  source_category_type?: string[];
}

// backend response
export interface RawSource extends RawHevoEntityMeta {
  id: number;
  seq_id: number;
  name: string;
  source_type: RawSourceType;
  status: {
    type: SourceStatus;
    display_text: string;
    hover_text?: string;
  };
  integrations_count?: number;
  source_actions: EntityRawAction<SourceAction>[] | null;
}

export enum SourceAction {
  DELETE = 'DELETE',
  EDIT = 'EDIT'
}
